import React from "react";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";

export class AuctionTabs extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
    this.state = {
      auctionId: auctionId,
    };
  }
  render() {
    let id = this.state.auctionId;
    let activeTab = this.props.activeTab;
    return (
      <React.Fragment>
        <ul className="nav nav-tabs">
          <li className={activeTab === "details" ? "active" : ""}>
            <Link to={"/edit_auction/" + id}>
              <i className="fa fa-info" />
              &nbsp;{i18n.t("details")}
            </Link>
          </li>
          <li className={activeTab === "uploader" ? "active" : ""}>
            <Link to={"/image_uploader/" + id}>
              <i className="fa fa-image" />
              &nbsp;{i18n.t("media_files")}
            </Link>
          </li>
          <li className={activeTab === "enquiry" ? "active" : ""}>
            <Link to={"/enquiries_details/" + id}>
              <i className="fa fa-phone" />
              &nbsp;{i18n.t("enquiry")}
            </Link>
          </li>
          <li className={activeTab === "contracts" ? "active" : ""}>
            <Link to={"/contracts/" + id}>
              <i className="fa fa-file-o" />
              &nbsp;{i18n.t("documents")}
            </Link>
          </li>
          <li className={activeTab === "terms" ? "active" : ""}>
            <Link to={"/terms/" + id}>
              <i className="fa fa-files-o" />
              &nbsp;{i18n.t("terms_conditions")}
            </Link>
          </li>
          <li className={activeTab === "additional" ? "active" : ""}>
            <Link to={"/additional/" + id}>
              <i className="fa fa-file-pdf-o" />
              &nbsp;{i18n.t("additional_info")}
            </Link>
          </li>
          <li className={activeTab === "vehicle" ? "active" : ""}>
            <Link to={"/vehicle/" + id}>
              <i className="fa fa-car" />
              &nbsp;{i18n.t("vehicle_info")}
            </Link>
          </li>
        </ul>
      </React.Fragment>
    );
  }
}
